"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
var apiResponse_1 = require("../apiResponse");
function CreateRenewal() {
    (0, react_1.useEffect)(function () {
        axios_1.default.post('/api/ministry/renewal')
            .then(function (response) {
            var _a;
            if (!(0, apiResponse_1.isJsonSuccess)(response)) {
                console.error('Unexpected response creating renewal', response.status, response.data);
                window.alert((0, Lang_js_1.__)('Your renewal could not be created. Please reload the page, and sign in again if you are prompted to.'));
                return;
            }
            if (!response.data.id) {
                console.error(response.data);
                window.alert((_a = response.data.message) !== null && _a !== void 0 ? _a : (0, Lang_js_1.__)('Your renewal could not be created. Please reload the page, and sign in again if you are prompted to.'));
            }
            else {
                window.location.href = "/app/ministry/renewal/edit/".concat(response.data.id);
            }
        })
            .catch(function (error) {
            console.error('There was an error!', error);
            window.alert((0, Lang_js_1.__)('Your renewal could not be created. Please reload the page, and sign in again if you are prompted to.'));
        });
    }, []);
    return null;
}
var createRenewalContainer = document.getElementById('create-renewal');
if (createRenewalContainer) {
    (0, mountIsland_1.mountIsland)(createRenewalContainer, react_1.default.createElement(CreateRenewal, null));
}
